import React from 'react';
import { Link } from 'react-router-dom';
import { bookPathFromClubRouteKey, shopPathFromClubRouteKey } from '../../utils/booking-nav-paths';
import { bookingBrandFontFamilyVar } from '../../styles/tebox-booking';

type Props = {
  active: 'book' | 'shop';
  clubRouteKey: string | null;
  textColor?: string;
  accentColor?: string;
  isMobile?: boolean;
};

export function BookingSubNav({
  active,
  clubRouteKey,
  textColor = '#111827',
  accentColor = '#111827',
  isMobile = false,
}: Props) {
  const bookPath = bookPathFromClubRouteKey(clubRouteKey);
  const shopPath = shopPathFromClubRouteKey(clubRouteKey);

  const tabStyle = (isActive: boolean): React.CSSProperties => ({
    fontFamily: bookingBrandFontFamilyVar,
    fontWeight: 500,
    fontSize: isMobile ? '14px' : '15px',
    color: isActive ? accentColor : textColor,
    textDecoration: 'none',
    paddingBottom: '8px',
    borderBottom: isActive ? `2px solid ${accentColor}` : '2px solid transparent',
  });

  return (
    <nav
      className="flex items-center gap-6 px-4 md:px-6"
      aria-label="Booking navigation"
    >
      <Link to={bookPath} style={tabStyle(active === 'book')}>
        Book
      </Link>
      <Link to={shopPath} style={tabStyle(active === 'shop')}>
        Shop
      </Link>
    </nav>
  );
}

export default BookingSubNav;
